import ServiceBase from "./_serviceBase";
import StorageService from "./storageService";
import {
  authMethode,
  authStorageKey,
  apiRoot,
  authPath,
} from "../General/globals";

class PageService extends ServiceBase {
  constructor(authBody) {
    super();
    this.authBody = authBody;
  }

  validateTokenExpiry(savedDateTime, expInSec) {
    if (!savedDateTime || typeof savedDateTime !== "string") {
      return false;
    }

    if (!expInSec) {
      return false;
    }

    const savedTimeInSeconds = Math.floor(
      new Date(savedDateTime).getTime() / 1000
    );
    if (isNaN(savedTimeInSeconds)) {
      return false;
    }

    const expirationInSeconds = parseInt(expInSec, 10);
    if (isNaN(expirationInSeconds)) {
      return false;
    }

    const currentTimeInSeconds = Math.floor(Date.now() / 1000);

    const expiryTime = savedTimeInSeconds + expirationInSeconds;
    return currentTimeInSeconds > expiryTime - 60;
  }

  async getRefreshedToken(refreshTokenEndpoint, refToken) {
    const reqBody = `grant_type=refresh_token&refresh_token=${refToken}`;
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
    };
    try {
      const response = await fetch(refreshTokenEndpoint, {
        method: "POST",
        headers,
        body: reqBody,
      });
      return response.json();
    } catch (error) {
      console.error(
        "Error refreshing token:",
        error.response?.data || error.message
      );
      throw error;
    }
  }

  async loadData(
    procKey,
    action_args,
    resultType,
    controllerName,
    offlineAccess
  ) {
    let currentToken = new StorageService().getJsonValue(authStorageKey);
    let authEndpoint = apiRoot + authPath;

    if (
      this.validateTokenExpiry(currentToken?.tm, currentToken?.ei) &&
      currentToken?.rt
    ) {
      const revalidateToken = await fetch("/init.json");
      const revalidateInit = await revalidateToken.json();

      if (revalidateInit?.service?.refreshToken) {
        let refreshedToken = await this.getRefreshedToken(
          authEndpoint,
          currentToken?.rt
        );
        if (refreshedToken && refreshedToken.access_token) {
          let stService = new StorageService();
          stService.setJsonValue(authStorageKey, {
            at: refreshedToken.access_token,
            tt: refreshedToken.token_type,
            ei: refreshedToken.expires_in,
            rt: refreshedToken.refresh_token ?? currentToken?.rt ?? null,
            tm: new Date(),
          });
        }
      }
    }

    // if (!currentToken && controllerName !== "unproc") return null;
    return await this.loadFromServer(
      this.authBody.job_id,
      procKey,
      currentToken?.at,
      { info: action_args },
      resultType,
      controllerName,
      offlineAccess
    );
  }

  async uploadFile(data) {
    //Untested; To contact the file processing end of API; Maybe the loadData function is enough
    let currentToken = new StorageService().getJsonValue(authStorageKey);
    if (!currentToken && authMethode !== "cookie") return null;

    return await this.sendFileToServer(
      this.authBody.job_id,
      currentToken.at,
      typeof data == "object" ? { info: data } : { info: { filedata: data } }
    );
  }
}

export default PageService;
